module.exports = __webpack_public_path__ + "assets/load.png?ef3160b9f3e6f6f80f3fab019634f81d";